// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qAUwR9a2fcaCfgefZ9Zc {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.xr95RLqWljBKT5boVkdK {
	background: #f3f3f3;
	border-radius: 12px;
	display: flex;
	flex-direction: column;
	padding: 16px;
}

.HkDDkpD7nOa_phNk2TVW {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 24px;
	opacity: 0.5;
}

.N2kOPwGcyqB9qSeLLcTe {
	align-items: center;
	display: flex;
	font-size: 32px;
	justify-content: space-between;
	letter-spacing: -0.08em;
	line-height: 44px;
	margin-bottom: 20px;
}

.DcSlHvFHfrtqvzsxfuOf {
	color: var(--brand);
}

.S_LoNrLOF8iftV7pkTPC {
	padding: 12px 16px;
	background-color: #fafafa;
	border-radius: 8px;
	color: #eb9711;
	margin-bottom: 12px;
	//text-align: center;
}

.bjETCCppeKMn5qMvdqQT {
	align-items: center;
	background: none;
	border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
	border-left: none;
	border-right: none;
	border-top: none;
	color: var(--black);
	cursor: pointer;
	display: flex;
	font-size: 16px;
	justify-content: space-between;
	letter-spacing: -0.08em;
	line-height: 24px;
	padding: 0 0 8px 0;
}

.XZzJKsv0ykFzjhTlnxQA {
	margin-bottom: 20px;
}

.OysRJtlN8Ht0rhOy2UOO {
	display: flex;
	flex-direction: column;
	margin-bottom: 20px;
}

.OysRJtlN8Ht0rhOy2UOO > *:not(:last-child) {
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
	}

.FrbJtBTopjexFjQU_GOe {
	transform: rotate(180deg);
}

._gFv7A8eRlySxtkO1nWL {
	display: flex;
	flex-direction: column;
	gap: 15px;
}

.UsLY73IXbXQNCiQneLK0 {
	color: var(--black);
	margin-bottom: 20px;
	opacity: 1;
	text-transform: uppercase;
}

.jlYB1ah4BoU1fU3zcjbL {
	color: var(--white) !important;
	height: 44px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/VESISPage/AboutLock/AboutLock.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,eAAe;CACf,8BAA8B;CAC9B,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,6CAA6C;CAC7C,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,eAAe;CACf,8BAA8B;CAC9B,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AAKpB;;AAHC;EACC,6CAA6C;CAC9C;;AAGD;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;CAC9B,uBAAuB;AACxB","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 20px;\n}\n\n.content {\n\tbackground: #f3f3f3;\n\tborder-radius: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 16px;\n}\n\n.title {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\topacity: 0.5;\n}\n\n.value {\n\talign-items: center;\n\tdisplay: flex;\n\tfont-size: 32px;\n\tjustify-content: space-between;\n\tletter-spacing: -0.08em;\n\tline-height: 44px;\n\tmargin-bottom: 20px;\n}\n\n.unlockButton {\n\tcolor: var(--brand);\n}\n\n.limitReached {\n\tpadding: 12px 16px;\n\tbackground-color: #fafafa;\n\tborder-radius: 8px;\n\tcolor: #eb9711;\n\tmargin-bottom: 12px;\n\t//text-align: center;\n}\n\n.aboutLockButton {\n\talign-items: center;\n\tbackground: none;\n\tborder-bottom: 0.5px solid rgba(0, 0, 0, 0.2);\n\tborder-left: none;\n\tborder-right: none;\n\tborder-top: none;\n\tcolor: var(--black);\n\tcursor: pointer;\n\tdisplay: flex;\n\tfont-size: 16px;\n\tjustify-content: space-between;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\tpadding: 0 0 8px 0;\n}\n\n.aboutHidden {\n\tmargin-bottom: 20px;\n}\n\n.about {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-bottom: 20px;\n\n\t& > *:not(:last-child) {\n\t\tborder-bottom: 0.5px solid rgba(0, 0, 0, 0.2);\n\t}\n}\n\n.chevron {\n\ttransform: rotate(180deg);\n}\n\n.buttons {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 15px;\n}\n\n.withdraw {\n\tcolor: var(--black);\n\tmargin-bottom: 20px;\n\topacity: 1;\n\ttext-transform: uppercase;\n}\n\n.switchNetwork {\n\tcolor: var(--white) !important;\n\theight: 44px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `qAUwR9a2fcaCfgefZ9Zc`,
	"content": `xr95RLqWljBKT5boVkdK`,
	"title": `HkDDkpD7nOa_phNk2TVW`,
	"value": `N2kOPwGcyqB9qSeLLcTe`,
	"unlockButton": `DcSlHvFHfrtqvzsxfuOf`,
	"limitReached": `S_LoNrLOF8iftV7pkTPC`,
	"aboutLockButton": `bjETCCppeKMn5qMvdqQT`,
	"aboutHidden": `XZzJKsv0ykFzjhTlnxQA`,
	"about": `OysRJtlN8Ht0rhOy2UOO`,
	"chevron": `FrbJtBTopjexFjQU_GOe`,
	"buttons": `_gFv7A8eRlySxtkO1nWL`,
	"withdraw": `UsLY73IXbXQNCiQneLK0`,
	"switchNetwork": `jlYB1ah4BoU1fU3zcjbL`
};
export default ___CSS_LOADER_EXPORT___;
